import React from "react";

export default function IconoObligatorio() {
  return <span style={{ color: "red", fontWeight: "bold" }}>*</span>;
}
